export default "__VITE_ASSET__DhgLvhI3__"